import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

type BreadcrumbsStore = {
  currentPath?: string;
  setCurrentPath: (currentPath: string) => void;
  prevPath?: string;
  setPrevPath: (prevPath?: string) => void;
};

const useBreadcrumbsStore = create<BreadcrumbsStore>()(
  persist(
    (set) => ({
      currentPath: undefined,
      setCurrentPath: (currentPath: string) => set({ currentPath }),
      prevPath: undefined,
      setPrevPath: (prevPath?: string) => set({ prevPath }),
    }),
    {
      name: "breadcrumbs",
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);

export default useBreadcrumbsStore;
